import React from "react";
import LoginPage from "../admin/login/Login";

function AdminLoginPage() {
  return (
    <div>
      <LoginPage />
    </div>
  );
}

export default AdminLoginPage;
